import { ensureRouteData } from '@/app/query-client'
import { fundDividendsQueryOptions } from '@/features/mutual-funds/api/queries'
import type { RouterContext } from '@/routes/layouts/root'

/**
 * The `/mutual-funds/dividends` loader.
 *
 * MAIN: both dividend lists, one payload, no parameters — so the screen reads
 * it with `useSuspenseFundDividends`. The page carries no search params.
 */
export async function loadDividends({
  context: { queryClient },
}: {
  context: RouterContext
}): Promise<void> {
  await ensureRouteData(queryClient, fundDividendsQueryOptions())
}
